const toggleClass = (element, addClass, removeClass) => {
    element === null || element === void 0 ? void 0 : element.classList.add(addClass);
    element === null || element === void 0 ? void 0 : element.classList.remove(removeClass);
};
const urlPerSection = window.location.href.split('/');
const handleNavbarVisibility = (scrollY) => {
    const navbar = document.querySelector('.navbar-nav-main');
    const navInputSearch = document.querySelector('.nav-input-search');
    const listSearch = document.querySelector('.list-search');
    const iconBrand = document.querySelector('.site-logo');
    const fullBrand = document.querySelector('.logo-slogan');
    const aviBtn = document.getElementById('avi-fab-wrapper');
    if (urlPerSection[3] === "") {
        if (scrollY > 470) {
            toggleClass(navbar, 'hide-logo', 'show-logo');
            toggleClass(navInputSearch, 'd-block', 'd-none');
            toggleClass(listSearch, 'list-fixed', '');
            aviBtn.classList.add('show');
            if (window.innerWidth < 900) {
                navInputSearch.style.width = "95%";
                fullBrand.classList.add('d-none');
                iconBrand.classList.remove('d-none');
            }
        }
        else {
            toggleClass(navbar, 'show-logo', 'hide-logo');
            toggleClass(navInputSearch, 'd-none', 'd-block');
            toggleClass(listSearch, '', 'list-fixed');
            aviBtn.classList.remove('show');
            if (window.innerWidth < 900) {
                navInputSearch.style.width = "95%";
                fullBrand.classList.remove('d-none');
                iconBrand.classList.add('d-none');
            }
        }
    }
};
export function handleNavbar() {
    window.addEventListener('load', () => {
        const navbar = document.querySelector('.navbar-nav-main');
        const navInputSearch = document.querySelector('.nav-input-search');
        const fullBrand = document.querySelector('.navbar__brand .logo-slogan');
        const iconBrand = document.querySelector('.navbar__brand .site-logo');
        if (urlPerSection[3] !== '') {
            toggleClass(navbar, 'hide-logo', 'show-logo');
            toggleClass(navInputSearch, 'd-block', 'd-none');
        }
        let currentUrl = window.location.href;
        if (urlPerSection[3] !== '') {
            if (document.getElementById('nav-search-container')) {
                if (window.innerWidth < 900) {
                    navInputSearch.style.width = "95%";
                    fullBrand.classList.add('d-none');
                    iconBrand.classList.remove('d-none');
                }
            }
        }
    });
    window.addEventListener('scroll', () => handleNavbarVisibility(window.scrollY));
}
